export const updateFormState = (payload) => ({
    type: 'UPDATE_PAYMENTS_FILTERS_FORM',
    payload
});



// WEBPACK FOOTER //
// ./src/components/Pages/Payments/actions.js